module.exports = __webpack_public_path__ + "img/x.91cf189c.svg";